import axios from "axios";
import { dispatchEvent } from "./firebase";
import { requestHeaders } from "./auth";

async function getRequestHeaders() {
  return await requestHeaders();
}

async function getAccountFromId() {
  const headers = await getRequestHeaders();
  const response = await axios({
    method: "GET",
    url: `${process.env["VUE_APP_FIREBASE_FUNCTION_SUBDOMAIN"]}/customer-getAccountFromId`,
    withCredentials: true,
    headers,
  });
  return response.data.doc;
}

async function getAccountStripePortal(returnUrl) {
  const headers = await getRequestHeaders();
  const response = await axios({
    method: "GET",
    url: `${process.env["VUE_APP_FIREBASE_FUNCTION_SUBDOMAIN"]}/customer-getAccountStripePortal`,
    params: { returnUrl },
    withCredentials: true,
    headers,
  });
  return response.data.stripeCustomerPortalUrl;
}

export {
  dispatchEvent,
  getAccountFromId,
  getAccountStripePortal,
};
